export default __webpack_public_path__ + "static/media/tutorial-1.d0030be9.svg";